import { onboardingQueryKeys as e } from "../onboarding/useOnboardingQueryKeys.mjs";
import { propertyQueryKeys as t } from "./usePropertiesQueryKeys.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { propertiesApi as i } from "@maat/api-main";
//#region src/properties/useCreatePropertyMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: i.createProperty,
		onSuccess: () => {
			a.invalidateQueries({ queryKey: t.list() }), a.invalidateQueries({ queryKey: t.hostFeed() }), a.invalidateQueries({ queryKey: e.status() });
		}
	});
};
//#endregion
export { a as useCreatePropertyMutation };
